import {  z } from 'zod'
import { documentSchema } from '../utils/basicSchemas/document.z.schema'
import { mongoId } from '../utils/basicSchemas/_id.z.schema'
import { ZSchema } from '../utils/zodSchema'

const challengeSchemaFull = z.object({
    challengeTitle: z.string({ required_error: "Challenge title is required" }),
    challengeDescription: z.string().optional(),
    challengeCreator: mongoId("Challenge Creator"),
    startTime: z.string().datetime({ message: " Start time is invalid" }),
    endTime: z.date({ required_error: "End time is required" }),
})

// Merging it with the document schema to set document fields like timestamps , _id & __v into it 
const challengeSchemaDoc = documentSchema.merge(challengeSchemaFull)


const challengeIdSchema = z.object({
    id: mongoId("Challenge id"),
})

const challengeSchema = z.object({
    challengeTitle: z.string()
        .min(1, "Challenge title must be at least one character")
        .max(30, "Challenge title must be at most 30 characters")
        .regex(/^(?=.*[a-z])[ 0-9a-zA-Z]{1,30}$/i, "Challenge Title is invalid").optional(),
        
    challengeDescription: z.string()
        .min(1, "Challenge Description must be at least one character")
        .max(300, "Challenge Description is required")
        .regex(/^.{1,300}$/, "Challenge Description is invalid")
        .optional(),

    startTime: z.string().datetime({ message: "Start time is invalid" }).optional(),
    endTime: z.string().datetime({ message: "End time is invalid" }).optional(),
})

const challengeUpdateSchema = z.object({
    challengeTitle: z.string()
        .min(1, "Challenge title must be at least one character")
        .max(30, "Challenge title must be at most 30 characters")
        .regex(/^(?=.*[a-z])[ 0-9a-zA-Z]{1,30}$/i, "Challenge Title is invalid").optional(),

    challengeDescription: z.string()
        .min(1, "Challenge Description must be at least one character")
        .max(300, "Challenge Description is required")
        .regex(/^.{1,300}$/, "Challenge Description is invalid")
        .optional(),

    challengeTag: mongoId("Challenge Tag").optional(),

    startTime: z.string().datetime({ message: "Start time is invalid" }).optional(),
    endTime: z.string().datetime({ message: "End time is invalid" }).optional(),
})


// Define and export validators 
const challengeIdValidator = new ZSchema({ paramSchema: challengeIdSchema })
const challengeValidator = new ZSchema({ bodySchema: challengeSchema })
const challengeUpdateValidator = new ZSchema({
    paramSchema: challengeIdSchema, bodySchema: challengeUpdateSchema
})

export { challengeIdValidator, challengeUpdateValidator, challengeValidator }

export { challengeSchema, challengeSchemaDoc }
